export default __webpack_public_path__ + "static/media/analogue-clock-face.6dcd4da8.png";